/**
 * Row extraction from a compute response for table tiles. Pure; used by the
 * table-matrix step at Generate time and by the shell on recompute results.
 */

/** Flat rows of a compute response: the array itself, `responseList[0].data`, `data` or `Data`. */
export function extractTableMatrixRows(response: Record<string, unknown> | null): Array<Record<string, unknown>> {
  if (response == null) return [];
  if (Array.isArray(response)) return response as Array<Record<string, unknown>>;
  const list = (response as { responseList?: Array<Record<string, unknown>> }).responseList;
  const fromList = Array.isArray(list) ? (list[0]?.['data'] as unknown) : undefined;
  const dataField = fromList ?? (response as { data?: unknown }).data ?? (response as { Data?: unknown }).Data;
  if (Array.isArray(dataField)) return dataField as Array<Record<string, unknown>>;
  return [];
}

/** Flatten a backend drill tree (`data[]` of nodes with children / measures) into leaf rows keyed by level label. */
export function flattenComputeTreeToRows(response: Record<string, unknown> | null): Array<Record<string, unknown>> {
  const tree = (response?.['data'] ?? response?.['Data'] ?? []) as Array<Record<string, unknown>>;
  if (!Array.isArray(tree)) return [];
  const out: Array<Record<string, unknown>> = [];
  const walk = (nodes: Array<Record<string, unknown>>, path: Record<string, unknown>): void => {
    for (const node of nodes || []) {
      const level = { ...path, [String(node['levelLabel'] ?? 'level')]: node['label'] };
      const children = node['children'] as Array<Record<string, unknown>> | undefined;
      if (Array.isArray(children) && children.length) {
        walk(children, level);
      } else {
        out.push({ ...((node['measures'] as Record<string, unknown>) || {}), ...level });
      }
    }
  };
  walk(tree, {});
  return out;
}
